<div style="background-color: #F5F7F8; height: 96vh; overflow-y: hidden; padding: 7px;  padding-top: 40px; overflow-x: hidden;">
    <h2 style="text-align: left; font-weight: 600; padding-left: 8px;">Групи</h2>
    <div class="row">
      <div class="input-group col-10" style="padding-left: 23px;">
        <span *ngIf="!this.searchedText" style="border: none; background-color: white; height: 38px;" class="input-group-text" id="basic-addon1"><i class="bi bi-search"></i></span>
        <input (focus)="this.searchFieldFocused = true" (blur)="this.resetFocusFromSearch()" (keydown.enter)="this.onGroupSearchTextChange($event)" (input)="this.onSearchTextChange($event)" style=" border: none; border-top-right-radius: 0.25em; border-bottom-right-radius: 0.25em;" type="text" class="form-control" formControlName="newPassword" [placeholder]="'Търси продукт'" [value]="this.searchedText || ''" aria-label="Username" aria-describedby="basic-addon1">
        <button *ngIf="this.searchFieldFocused || (this.searchedText != '')" (click)="this.clearSeacrhedText()" type="button" class="btn bg-transparent" style="margin-left: -35px; z-index: 100;">
          <i class="fa fa-times" style="content: url('/assets/images/home/cross.svg');"></i>
        </button>
      </div>
      <div class="col-2" style="padding-left: 0px;">
        <button (click)="this.open(order)"  style="border-radius: 0.25em; width: 38px; height: 38px; border: none; background-color: white;" type="button" data-bs-toggle="offcanvas" data-bs-target="#staticBackdrop" aria-controls="staticBackdrop">
          <img src="/assets/images/home/icon-sort.svg" alt="">
      </button>
      </div>
    </div>
    <mat-chip-list class="container-fluid" style="overflow: scroll; height: 50px;">
        <div class="container-fluid" style="overflow: scroll;">
            <div class="row flex-row flex-nowrap">
                <mat-chip
                    style="padding: 20px 20px; width: fit-content;"
                    [class]="category.uuid == this.selectedCategory ? 'example-box active' : 'example-box'"
                    *ngFor="let category of categories.data"
                    (click)="this.onChipClicked(category.uuid)">
                    {{category.name}}
                </mat-chip>
            </div>
        </div>
    </mat-chip-list>
    <div *ngIf="(this.ds && !this.ds!.groupsLength && !this.ds!.loading) || this.noGroups"
      style="text-align: center; display: grid; justify-content: center; width: 100%; align-content: center;">
      <img src="/assets/images/home/nothing-found.svg" alt="" style="margin: auto; display: block; margin-top: 40px; margin-bottom: 20px;">
      <p style="width: 90%; text-align: center; color: #ADAFBB; margin: auto; margin-top: 10px;">
         Няма създадена група. Създайте и спестете от следващата си поръчка
      </p>
    </div>
    <cdk-virtual-scroll-viewport *ngIf="!((this.ds && !this.ds!.groupsLength && !this.ds!.loading) && this.noGroups)" [itemSize]="165" class="example-viewport group" style="height: 63vh; overflow-x: hidden; width: 100%;">
          <div  *cdkVirtualFor="let item of ds; index as i; templateCacheSize: 0" class="example-item col-12" style="height: 165px;">
            <div  *ngIf="item" style="height: 155px; margin-bottom: 10px;">
              <div class="card " style="height: 155px; margin-bottom: 10px; border: unset; max-width: 540px; padding: 10px; background-color: white;  border-radius: 9px;">
                <div class="row" (click)="this.goToGroup(item.uuid)">
                  <div class="col-4">
                    <img [src]="item.imageURL" class="card-img img-fluid"  style="height: 120px;" alt="...">
                  </div>
                  <div class="col-8" style="padding: 0px; padding-right: 5px;">
                      <p style="margin-bottom: 5px;
                                display: -webkit-box;-webkit-line-clamp: 3; line-clamp: 3;
                                -webkit-box-orient: vertical; height: 63px; overflow: hidden;
                                text-overflow: ellipsis; margin-top: 5px; text-overflow: ellipsis;">
                                {{ item.productInfo?.data.name }}
                      </p>
                      <p style="margin-bottom: 5px; color: #79798B; font-size: 10px;">
                        Поръчани:
                        <span style="color: #0A69EB;">{{ item.quantity_reserved }}</span>
                        <span style="color: #79798B;"> | </span>
                        Оставащо време:
                        <span style="color: #0A69EB;">
                          {{ item.expiration?.hours + ' ' + item.expiration?.minutes }}
                        </span>
                      </p>
                      <div class="group-card-price-row">
                        <app-price
                          class="group-card-current-price"
                          [amount]="getGroupCardCurrentPriceBase(item)"
                          layout="inline"
                        ></app-price>

                        <span
                          *ngIf="shouldShowGroupOldPrice(item)"
                          class="group-card-old-price"
                        >
                          <app-price
                            class="group-card-old-price-value"
                            [amount]="getGroupCardOldPriceBase(item)"
                            layout="inline"
                            fontWeight="normal"
                          ></app-price>
                        </span>
                      </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</div>



<ng-template #order let-modal>
  <div style="padding-top: 10px !important; padding-bottom: 10px !important;">
    <h3 class="offcanvas-title" id="staticBackdropLabel" style="text-align: center; font-weight: 700; width: 100%;">Подреди по:</h3>
    <!-- <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button> -->
    <div style="width: 100%;">
      <ul class="list-group list-group-flush" style="width: 80%; margin: auto; list-style-type: none;">
        <li style="position: relative; top: -5px;"  (click)="this.selectOrder('-discount', 'discount', modal)" [id]="this.selectedOrder == 'Най-голяма отстъпка' ? 'active' : ''">Най-голяма отстъпка</li>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <li style="position: relative; top: -5px;" (click)="this.selectOrder('-created', 'new', modal)" [id]="this.selectedOrder == 'Най-нови' ? 'active' : ''">Най-нови</li>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <li style="position: relative; top: -5px;" (click)="this.selectOrder('created', 'old', modal)" [id]="this.selectedOrder == 'Най-стари' ? 'active' : ''">Най-стари</li>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <li style="position: relative; top: -5px;" (click)="this.selectOrder('price', 'price', modal)" [id]="this.selectedOrder == 'Най-ниска цена' ? 'active' : ''">Най-ниска цена</li>

      </ul>
    </div>
  </div>
</ng-template>
